import { Pie, PieChart, ResponsiveContainer, Cell } from 'recharts';
import styles from './styles.module.scss';

// const data = [
//   { name: 'Сделано', value: 7, fill: '#108773ff' },
//   { name: 'Не хватает', value: 4, fill: '#c3e5dfff' },
// ];
interface PieKBGUProps {
  data: { value: number }[];
  colors: string[];
  centerText?: string;
  centerSubText?: string;
  isAnimationActive?: boolean;
  photo: string;
}
export default function PieKBGU({
  data,
  colors,
  centerText,
  centerSubText,
  isAnimationActive = true,
  photo,
}: PieKBGUProps) {
  return (
    <div className={styles.container}>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart
          style={{
            width: '100%',
            height: '100%',
            maxWidth: '500px',
            maxHeight: '80vh',
            aspectRatio: 1,
          }}
          // responsive
        >
          <Pie
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="80%"
            // cornerRadius="80%"

            // padding angle is the gap between each pie slice
            paddingAngle={5}
            label
            isAnimationActive={isAnimationActive}
          >
            {' '}
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className={styles.centerContent}>
        <div className={styles.center}>
          <img
            src={photo}
            alt="Логотип киберфит"
            className={styles.icon}
            //   onError={(e) => {
            //     // Fallback если изображение не загружается
            //     e.currentTarget.style.display = 'none';
            //   }}
          />
          <div className={styles.textcontainer}>
            <div className={styles.text}>{centerText}</div>
            <div className={styles.value}>{centerSubText} </div>
          </div>
        </div>
      </div>
    </div>
  );
}
